<template>
  <div>
    <div class="content">
      <div class="top">融资需求明细</div>
      <div class="from">
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item label="需求编号">
            <el-input v-model="form.demandNo" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="受理状态">
            <el-select v-model="form.status" clearable style="width:150px">
              <el-option v-for="item in belongAreaArr" :key="item.id" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryInfo">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tab">
        <el-table :data="applyProList" style="width: 100%">
          <el-table-column prop="demandNo" :align="'center'" label="需求编号" width="180">
          </el-table-column>
          <el-table-column prop="enterpriseName" :align="'center'" label="企业名称" width="250">
          </el-table-column>
           <el-table-column prop="enterpriseCode" :align="'center'" label="统一社会信用代码" width="200">
          </el-table-column>
          <el-table-column prop="contact" :align="'center'" label="联系人" width="250">
          </el-table-column>
          <el-table-column prop="phone" :align="'center'" label="联系人手机号" width="150">
          </el-table-column>
          <el-table-column prop="purposeLoanAmount" :align="'center'" label="意向贷款金额(万元)" width="200">
          </el-table-column>
          <el-table-column prop="status" :align="'center'" label="受理状态" width="200">
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="this.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selectDemandList } from '@/api/ydm'
export default {
  name:'FinanceDetail',
  props:{
    getSourceType: String,
  },
  data() {
    return {
      belongAreaArr:[
        {
          id:1,
          label:'已受理'
        },
        {
          id:2,
          label:'未受理'
        }
      ],
      form: {
        submitType: "苏商通用户",
        demandNo:'',
        status:'',
        enterpriseCode:'',//统一社会信用代码
        page: 1,
        pageSize: 10
      },
      applyProList: [],
      total: 0
    };
  },
  methods: {
    // 查询
    queryInfo() {
      this.form.page = 1
      this.getcheckinListList();
    },
    async getcheckinListList() {
      let searchForm = {
        ...this.form
      }
      if(this.getSourceType == '1'){
        searchForm.enterprisecode == ''
      }
      // 企业
      selectDemandList(searchForm).then(res=>{
        if(res.data.code == 200){
          this.applyProList = res.data.data.list;
          this.total = res.data.data.total;
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getcheckinListList();
    }
  },
  mounted(){
    this.form.enterpriseCode =JSON.parse(sessionStorage.getItem('user')).sstCustom.oucode
    this.getcheckinListList();
  }

};
</script>
<style lang='less' scoped>
.content {
  min-height: 894px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 1050px;
  .top {
    height: 30px;
    border-left: 8px solid #2981ee;
    padding-left: 38px;
    box-sizing: border-box;
    font-size: 22px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2981ee;
    line-height: 30px;
  }
  .from {
    margin-top: 37px;
    margin-left: 38px;
  }
  .dowm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    box-sizing: border-box;
    /deep/ .el-button {
      width: 157px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      color: #fff;
    }
  }
  .tab {
    box-sizing: border-box;
    margin-top: 15px;
    min-height: 700px;
    user-select: text;
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-table th {
      background: #f3f4f9;
    }
  }

}
</style> 